module.exports = __webpack_public_path__ + "static/media/1019883.1f807b42.jpg";